<template>
  <ul @click="onPagerClick" class="zm-pager">
    <li
      :class="{ active: currentPage === 1, disabled }"
      v-if="pageCount > 0 && !noJump"
      class="number"
      role="button"
      :aria-label="getAria(1)"
      :tabindex="disabled?-1:0"
    >1
    </li>
    <li
      class="zm-icon more btn-quickprev"
      :class="[quickprevIconClass]"
      v-if="showPrevMore && !noJump">
    </li>
    <li
      v-for="pager in pagers"
      :key="pager"
      :class="{ active: currentPage === pager, disabled }"
      class="number"
      role="button"
      :tabindex="disabled?-1:0"
      :aria-label="getAria(pager)"
    >{{ pager }}
    </li>
    <li
      class="zm-icon more btn-quicknext"
      :class="[quicknextIconClass]"
      v-if="showNextMore && !noJump">
    </li>
    <li
      :class="{ active: currentPage === pageCount, disabled }"
      class="number"
      v-if="pageCount > 1 && !noJump"
      role="button"
      :tabindex="disabled?-1:0"
      :aria-label="getAria(pageCount)"
    >{{ pageCount }}
    </li>
  </ul>
</template>

<script type="text/babel">
  import '../../../i18n/pagination';

  export default {
    name: 'ZmPager',

    props: {
      currentPage: Number,

      pageCount: Number,

      noJump: Boolean,

      pagerCount: Number,

      disabled: Boolean
    },

    watch: {
      showPrevMore(val) {
        if (!val) this.quickprevIconClass = 'zm-icon-more';
      },

      showNextMore(val) {
        if (!val) this.quicknextIconClass = 'zm-icon-more';
      }
    },

    methods: {
      onPagerClick(event) {
        const target = event.target;
        if (target.tagName === 'UL' || this.disabled || event.target.className.indexOf('more') !== -1) {
          return;
        }

        let newPage = Number(event.target.textContent);
        const pageCount = this.pageCount;
        const currentPage = this.currentPage;
        // const pagerCountOffset = this.pagerCount - 2;
        //
        // if (target.className.indexOf('more') !== -1) {
        //   if (target.className.indexOf('quickprev') !== -1) {
        //     newPage = currentPage - pagerCountOffset;
        //   } else if (target.className.indexOf('quicknext') !== -1) {
        //     newPage = currentPage + pagerCountOffset;
        //   }
        // }

        /* istanbul ignore if */
        if (!isNaN(newPage)) {
          if (newPage < 1) {
            newPage = 1;
          }

          if (newPage > pageCount) {
            newPage = pageCount;
          }
        }

        if (newPage !== currentPage) {
          this.$emit('change', newPage);
        }
      },

      getAria(page) {
        let aria = `Go to page ${page}`
        if (page === this.currentPage) {
          aria += ',current page';
        }
        return aria;
      }

      // onMouseenter(direction) {
      //   if (this.disabled) return;
      //   if (direction === 'left') {
      //     this.quickprevIconClass = 'zm-icon-left';
      //   } else {
      //     this.quicknextIconClass = 'zm-icon-right';
      //   }
      // }
    },

    computed: {
      pagers() {
        const pagerCount = this.pagerCount;
        const halfPagerCount = (pagerCount - 1) / 2;

        const currentPage = Number(this.currentPage);
        const pageCount = Number(this.pageCount);

        let showPrevMore = false;
        let showNextMore = false;

        if (pageCount > pagerCount) {
          if (currentPage > pagerCount - halfPagerCount) {
            showPrevMore = true;
          }

          if (currentPage < pageCount - halfPagerCount) {
            showNextMore = true;
          }
        }

        const array = [];
        if (this.noJump) {
          array.push(currentPage)
        } else {
          if (showPrevMore && !showNextMore) {
            const startPage = pageCount - (pagerCount - 2);
            for (let i = startPage; i < pageCount; i++) {
              array.push(i);
            }
          } else if (!showPrevMore && showNextMore) {
            for (let i = 2; i < pagerCount; i++) {
              array.push(i);
            }
          } else if (showPrevMore && showNextMore) {
            const offset = Math.floor(pagerCount / 2) - 1;
            for (let i = currentPage - offset; i <= currentPage + offset; i++) {
              array.push(i);
            }
          } else {
            for (let i = 2; i < pageCount; i++) {
              array.push(i);
            }
          }
        }

        this.showPrevMore = showPrevMore;
        this.showNextMore = showNextMore;

        return array;
      }
    },

    data() {
      return {
        current: null,
        showPrevMore: false,
        showNextMore: false,
        quicknextIconClass: 'zm-icon-more',
        quickprevIconClass: 'zm-icon-more'
      };
    }
  };
</script>

<style lang="scss">
  @import "../../scss/mixins/mixins";
  @import "../../scss/common/var";
  @import "../../scss/mixins/utils";

  @include b(pagination) {
    white-space: nowrap;
    padding: 2px 0;
    color: $--pagination-color;
    font-weight: bold;
    @include utils-clearfix;

    & > span:not([class*=suffix]),
    & > button {
      display: inline-block;
      font-size: $--pagination-font-size;
      min-width: $--pagination-button-width;
      height: $--pagination-button-height;
      line-height: $--pagination-button-height - 2;
      vertical-align: top;
      box-sizing: border-box;
    }
    & .zm-select .zm-select-input .zm-button {
      margin-top: -8px;
    }

    .zm-input__inner {
      text-align: center;
      -moz-appearance: textfield;
      line-height: 30px;
    }

    // pagesize 的下拉 icon
    .zm-input__suffix {
      right: 0;
      transform: scale(.8);
    }

    .zm-select .zm-input {
      width: 100px;
      margin: 0 5px;

      .zm-input__inner {
        padding-right: 25px;
        border-radius: $--pagination-border-radius;
      }
    }

    button {
      border: none;
      padding: 0 6px;
      background: transparent;

      &:focus {
        outline: none;
      }

      &:hover {
        color: $--pagination-hover-fill;
      }

      &:disabled {
        color: $--pagination-button-disabled-color;
        background-color: $--pagination-button-disabled-fill;
        opacity: 0.8;
        cursor: not-allowed;
      }
    }

    .btn-prev,
    .btn-next {
      background: center center no-repeat;
      background-size: 16px;
      background-color: $--pagination-fill;
      cursor: pointer;
      margin: 0;
      color: $--pagination-button-color;

      .zm-icon {
        display: block;
        font-size: 14px;
        font-weight: bold;
      }
    }

    .btn-prev {
      padding-right: 12px;
    }

    .btn-next {
      padding-left: 12px;
    }

    .zm-pager li.disabled {
      color: $--color-text-placeholder;
      cursor: not-allowed;
      opacity: 0.8;
    }

    @include m(small) {
      .btn-prev,
      .btn-next,
      .zm-pager li,
      .zm-pager li.btn-quicknext,
      .zm-pager li.btn-quickprev,
      .zm-pager li:last-child {
        border-color: transparent;
        font-size: 12px;
        line-height: 22px;
        height: 22px;
        min-width: 22px;
      }

      .arrow.disabled {
        visibility: hidden;
      }

      .more::before,
      li.more::before {
        line-height: 24px;
      }

      span:not([class*=suffix]),
      button {
        height: 22px;
        line-height: 22px;
      }

      @include e(editor) {
        height: 22px;
        &.zm-input .zm-input__inner {
          height: 22px;
        }
      }
    }

    @include e(sizes) {
      margin: 0 10px 0 0;
      font-weight: normal;
      color: $--color-text-primary;

      .zm-input .zm-input__inner {
        font-size: $--pagination-font-size;
        padding-left: 8px;

        &:hover {
          border-color: $--pagination-hover-fill;
        }
      }
      .zm-select {
        width: 120px;
      }
    }

    @include e(total) {
      margin-right: 10px;
      font-weight: normal;
      color: $--color-text-primary;
    }

    @include e(jump) {
      font-weight: normal;
      color: $--color-text-primary;

      .zm-input__inner {
        padding: 0 3px;
      }
    }

    @include e(rightwrapper) {
      float: right;
    }

    @include e(editor) {
      padding: 0 2px;

      text-align: center;
      margin: 0 2px;
      box-sizing: border-box;
      border-radius: $--pagination-border-radius;

      &.zm-input {
        width: 50px;
      }

      .zm-input__inner::-webkit-inner-spin-button,
      .zm-input__inner::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }
    }

    @include when(background) {
      .zm-pagination__sizes .zm-select {
        .zm-select-input {
          border-color: #F2F2F7;
          background-color: #F2F2F7;
          &:hover {
            background-color: #E7F1FD;
            border-color: #E7F1FD;
            .zm-select-span__inner {
              color: #0E71EB;
            }
          }
        ;
          &.is-focus {
            border-color: #D7E6F8;
            background-color: #D7E6F8;
            .zm-select-span__inner {
              color: #0E71EB;
            }
          }
        }
      }
      .btn-prev,
      .btn-next,
      .zm-pager li:not(.more) {
        margin: 0 5px;
        background-color: $--color-background-secondary;
        color: $--color-text-primary;
        min-width: 30px;
        border-radius: 8px;

        &.disabled {
          color: $--color-text-placeholder;
          opacity: 0.8;
        }
      }
      .btn-prev, .btn-next {
        padding: 0;
        &:hover {
          color: $--pagination-hover-fill;
          background-color: #E7F1FD;
        }
        &:active {
          color: $--pagination-hover-fill;
          background-color: #D7E6F8;
        }
        &:disabled {
          color: $--color-text-placeholder;
          opacity: 0.8;
          background-color: #F2F2F7
        }
      }

      .zm-pager li:not(.disabled) {
        &:not(.more):hover {
          color: $--pagination-hover-fill;
          background-color: #E7F1FD;
        }
        &:not(.more):active {
          background-color: #D7E6F8;
          color: $--pagination-hover-fill;
        }
        &.active {
          &:hover {
            background-color: $--pagination-hover-fill;
            color: $--color-white;
          }
          &:active {
            background-color: $--pagination-hover-fill;
            color: $--color-white;
          }
          background-color: $--pagination-hover-fill;
          color: $--color-white;
        }
      }

      &.zm-pagination--small {
        .btn-prev,
        .btn-next,
        .zm-pager li {
          margin: 0 3px;
          min-width: 22px;
        }
      }
    }
  }

  @include b(pager) {
    user-select: none;
    list-style: none;
    display: inline-block;
    vertical-align: top;
    font-size: 0;
    padding: 0;
    margin: 0;

    .more::before {
      line-height: 30px;
    }

    li {
      padding: 0 2px;
      margin: 0 2px;
      background: $--pagination-fill;
      vertical-align: top;
      display: inline-block;
      font-size: $--pagination-font-size;
      min-width: $--pagination-button-width;
      height: $--pagination-button-height;
      line-height: $--pagination-button-height;
      box-sizing: border-box;
      text-align: center;

      &:not(.more) {
        cursor: pointer;
      }
      &.btn-quicknext,
      &.btn-quickprev {
        line-height: 24px;
        color: $--pagination-button-color;

        &.disabled {
          color: $--color-text-placeholder;
          opacity: 0.8;
        }
      }

      &:focus {
        outline: none;
      }

      &.active + li {
        border-left: 0;
      }

      &:not(.more):hover {
        color: $--pagination-hover-fill;
      }

      &.active {
        color: $--pagination-hover-fill;
        cursor: default;
      }
    }
  }

  .is-keyboard-event {
    .zm-pagination {
      button, li {
        &:focus {
          outline: 1px solid $--color-primary;
        }
      }
    }
  }
</style>
